import { Box, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      {/* Icon */}
      <ErrorOutlineIcon sx={{ fontSize: 80, color: "#8F3232", mb: 2 }} />

      {/* Tiêu đề */}
      <Typography variant="h4" fontWeight={600} gutterBottom>
        404 - Trang không tồn tại
      </Typography>

      {/* Nội dung mô tả */}
      <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
        Xin lỗi, trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển.
      </Typography>

      {/* Link quay lại trang chủ */}
      <Button 
  variant="contained" 
  color="primary" 
  component={Link} 
  to="/"
  sx={{
    textTransform: "none", // Giữ nguyên chữ thường/thường không viết hoa
    '&:hover': {
      backgroundColor: '#8F3232', // Giữ nguyên màu nền
      color: 'white', // Giữ nguyên màu chữ
    }
  }}
>
  Quay lại trang chủ
</Button>
    </Box>
  );
};

export default PageNotFound;
